import { createReducer } from "typesafe-actions";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import NoteCompletionCardConfiguration from "@app/types/dashboard/cards/noteCompletion/NoteCompletionCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyNoteCompletionDrillDownListViewSettings,
  fetchNoteCompletionCardDrillDownData,
  hideNoteCompletionDrillDown,
  NoteCompletionCardActions,
  showNoteCompletionDrillDown,
} from "./actions";

export interface NoteCompletionCardState {
  configuration?: NoteCompletionCardConfiguration; // also works as a "visible" trigger, visible if set
  drillDownCustomDateRange?: DateRange;
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const noteCompletionInitialState: NoteCompletionCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const noteCompletionState = createReducer<NoteCompletionCardState, NoteCompletionCardActions>(
  noteCompletionInitialState
)
  .handleAction(showNoteCompletionDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
    drillDownCustomDateRange: payload.customDateRange,
  }))
  .handleAction(showNoteCompletionDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideNoteCompletionDrillDown, (state) => ({
    ...state,
    configuration: undefined,
    drillDownCustomDateRange: undefined,
  }))
  .handleAction(fetchNoteCompletionCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchNoteCompletionCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchNoteCompletionCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyNoteCompletionDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default noteCompletionState;
